var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPaginationShown)?_c('gl-pagination',{attrs:{"value":_vm.pagination.currentPage,"per-page":_vm.pagination.perPage,"total-items":_vm.pagination.totalItems,"link-gen":_vm.paginationLinkGenerator,"align":"center"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }